/**
 * @returns {Vue.Component} vue
 */
export const createFileUploaderProgress = () => {
  return {
    data() {
      return {
        uploadProgress: 0,
        startTime: null,
        totalElapsedTime: 0,
        redirectNoticeFlag: false,
        redirectedFlag: false,
        calcStartTime: null,
        lastUploadedBytes: 0,
        remainingTime: null,
        uploadSpeed: 0,
        lastUploadSpeeds: [],

        fileSizeInMB: '',
        uploadedFileSizeInMB: '',
        remainingBytesInMB: 0,
      }
    },
    computed: {
      remainingTimeInMinSec() {
        let hours = Math.floor((this.remainingTime || 0) / 3600) || 0;
        let minutes =
          Math.floor(((this.remainingTime || 0) - hours * 3600) / 60) || 0;
        let seconds =
          (this.remainingTime || 0) - hours * 3600 - minutes * 60 || 0;
        hours = hours > 0 ? Math.floor(hours) : 0;
        minutes = minutes > 0 ? Math.floor(minutes) : 0;
        seconds = seconds > 0 ? Math.floor(seconds) : 0;

        if (hours === 0) {
          if (minutes === 0) {
            return `${seconds} Seconds`;
          } else {
            return `${this.$t("about")} ${minutes} ${minutes?.length > 1 ? 'Minutes' : 'Minute'}`;
          }
        } else {
          return `${this.$t("about")} ${hours} ${hours?.length > 1 ? 'Hours' : 'Hour'} ${minutes} Minutes`;
        }
      },
    },
    methods: {
      formatBytes(bytes) {
        if (bytes < 1024) return bytes + " B";
        else if (bytes < 1048576) return (bytes / 1024).toFixed(2) + " KB";
        else if (bytes < 1073741824) return (bytes / 1048576).toFixed(2) + " MB";
        else return (bytes / 1073741824).toFixed(2) + " GB";
      },
      onUploadProgress(progressEvent) {
        this.uploadProgress = Math.round(
          (progressEvent.loaded / progressEvent.total) * 100
        );
        if (this.calcStartTime === null) {
          this.calcStartTime = new Date().getTime();
          this.startTime = new Date().getTime();
          return;
        }
        const elapsedTime =
          (new Date().getTime() - this.calcStartTime) / 1000;
        this.totalElapsedTime =
          (new Date().getTime() - this.startTime) / 1000;



        const uploadedBytes = progressEvent.loaded - this.lastUploadedBytes;
        this.lastUploadedBytes = progressEvent.loaded;
        this.insertNewUploadSpeed(uploadedBytes / elapsedTime);

        this.fileSizeInMB = this.formatBytes(progressEvent.total);
        this.uploadedFileSizeInMB = this.formatBytes(progressEvent.loaded);

        const remainingBytes = progressEvent.total - progressEvent.loaded;
        this.remainingBytesInMB = this.formatBytes(remainingBytes);

        this.remainingTime = remainingBytes / this.getAverageUploadSpeed();

        // console.log({'imports.vue:693 this.totalElapsedTime' : this.totalElapsedTime});
        if (this.totalElapsedTime > 5 && !this.redirectNoticeFlag && !this.redirectedFlag && this.remainingTime > 10) {
          this.redirectNoticeFlag = true;
        } else if (this.remainingTime < 10) {
          this.redirectNoticeFlag = false;
        }

        this.calcStartTime = new Date().getTime();
      },
      resetUploadSpeed() {
        this.lastUploadSpeeds = [];
      },
      insertNewUploadSpeed(speed) {
        if (this.lastUploadSpeeds.length > 3) {
          this.lastUploadSpeeds.shift();
        }
        this.lastUploadSpeeds.push(speed);
      },
      getAverageUploadSpeed() {
        return (
          this.lastUploadSpeeds.reduce((accum, cur) => accum + cur, 0) /
          this.lastUploadSpeeds.length || 1
        );
      },
      resetUploaderData() {
        this.uploadProgress = 0;
        this.startTime = null;
        this.totalElapsedTime = 0;
        this.redirectNoticeFlag = false;
        this.redirectedFlag = false;
        this.calcStartTime = null;
        this.lastUploadedBytes = 0;
        this.remainingTime = null;
        this.uploadSpeed = 0;
        this.lastUploadSpeeds = [];
      },
    }
  }
}